import {NavLink, useBlocker} from 'react-router-dom';
import styled from 'styled-components';
import {Button, ButtonGroup} from '@/components/Button';
import {Footer} from '@/components/Footer';
import {Modal} from '@/components/Modal';
import {
  SidePanelBase,
  SidePanelScrollBody,
} from '@/components/SidePanel/StyledComponents';
import {Typography, typographyStyle} from '@/components/Typography';
import {useSession} from '@/hooks';
import {paths} from '@/router';
import {Divider, FlexFullGrow, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import {MoreMenuGroup, MoreMenuItem} from './StyledComponents';
import {UserSection} from './UserSection';

export const MoreMenu = () => {
  const {isSmartStoreActiveUser} = useSession();

  let blocker = useBlocker(
    ({currentLocation, nextLocation}) =>
      !nextLocation.pathname.startsWith(paths.map_root) &&
      currentLocation.pathname !== nextLocation.pathname,
  );

  return (
    <Root>
      {blocker.state === 'blocked' && (
        <Modal
          title="분석 내용 초기화"
          width={328}
          onClose={() => blocker?.reset?.()}
        >
          <PaddingBox spacing={24}>
            <Typography variant="medium14" color={palette.gray600}>
              현재 분석 중인 내용이 초기화됩니다.
              <br />
              페이지를 이동하시겠어요?
            </Typography>
            <PaddingBox top={24}>
              <ButtonGroup flex={1} spacing={2}>
                <Button
                  variant="outline"
                  color="black"
                  size="mediumLarge"
                  onClick={() => blocker?.reset?.()}
                >
                  아니요
                </Button>
                <Button
                  variant="fill"
                  color="secondary"
                  size="mediumLarge"
                  onClick={() => blocker?.proceed?.()}
                >
                  네
                </Button>
              </ButtonGroup>
            </PaddingBox>
          </PaddingBox>
        </Modal>
      )}
      <Box>
        <UserSection />
      </Box>
      <SidePanelScrollBody>
        <MoreMenuGroup>
          <NavLink to={{pathname: paths.mypage_account}}>
            <MoreMenuItem>개인 정보 관리</MoreMenuItem>
          </NavLink>
          <NavLink to={{pathname: paths.mypage_pay}}>
            <MoreMenuItem>이용 이력</MoreMenuItem>
          </NavLink>
          <Divider />
          <NavLink to={{pathname: paths.intro}}>
            <MoreMenuItem>서비스 소개</MoreMenuItem>
          </NavLink>
          <NavLink to={{pathname: paths.pricing_root}}>
            <MoreMenuItem>요금제</MoreMenuItem>
          </NavLink>
          {isSmartStoreActiveUser && (
            <TicketWrapper>
              <SmartStoreTicket>
                <TicketDot />
                스마트상점 이용권 사용 중
              </SmartStoreTicket>
            </TicketWrapper>
          )}
        </MoreMenuGroup>
        <FlexFullGrow />
        <Footer columnLayout hideCompanyInfo />
      </SidePanelScrollBody>
    </Root>
  );
};

const TicketWrapper = styled.div`
  padding: 0 16px;
`;


const SmartStoreTicket = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1.5px dashed #34c78a;
  border-radius: 8px;
  background: #f0faf5;
  color: #1a7a4a;
  ${typographyStyle.medium14}
  white-space: nowrap;
`;

const TicketDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #34c78a;
  flex-shrink: 0;
`;

const Box = styled.div`
  padding: 24px 16px;
  background-color: ${palette.white};
`;

const Root = styled(SidePanelBase)`
  background-color: ${palette.gray100};
  gap: 8px;
  ${SidePanelScrollBody} {
    display: flex;
    flex-direction: column;
  }
  ${FlexFullGrow} {
    background-color: ${palette.white};
  }
`;
